import { useContext, useMemo } from 'react';
import { assertIsDefined } from '@/helpers/assertions';
import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { NewFeatureContext } from '@/providers/NewFeatureContextProvider/NewFeatureContextProvider';

const uat = import.meta.env.VITE_UAT_WEB_URL;
const localhost = import.meta.env.VITE_LOCALHOST_URL;

export const useNewFeatureManager = () => {
  const origin = window.location.origin;
  const featureFlag = window.localStorage.getItem('newFeatureEnabled');
  const alertingFeatureFlag = window.localStorage.getItem('alertingEnabled');

  const isPermitted = useMemo(() => {
    return origin === uat || origin === localhost || featureFlag === 'true';
  }, [featureFlag, origin]);

  const isAlertingPermitted = useMemo(() => {
    return origin === uat || origin === localhost || alertingFeatureFlag === 'true';
  }, [alertingFeatureFlag, origin]);

  const { user } = useNewAuth();
  const isBetaUserPermitted = user?.isBetaUser || false;

  return {
    isNewFeaturePermitted: isPermitted,
    isAlertingPermitted: isAlertingPermitted,
    isBetaUserFeature: isBetaUserPermitted,
  };
};

export const useNewFeature = () => {
  const { isNewFeaturePermitted, isAlertingPermitted, isBetaUserFeature } =
    useContext(NewFeatureContext);

  assertIsDefined(
    isNewFeaturePermitted,
    '"INewFeatureContext.isNewFeaturePermitted has to be defined!"',
  );
  assertIsDefined(
    isAlertingPermitted,
    '"INewFeatureContext.isAlertingPermitted has to be defined!"',
  );

  assertIsDefined(isBetaUserFeature, '"INewFeatureContext.isBetaUserFeature has to be defined!"');

  return {
    isNewFeaturePermitted,
    isAlertingPermitted,
    isBetaUserFeature,
  };
};
